import React, { useState } from "react";
import { Box, Tabs, Tab, Card, CardContent } from "@mui/material";

import ShopifyMarginRulesSubTab from "./Configuration/ShopifyMarginRulesSubTab";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`credentials-tabpanel-${index}`}
    aria-labelledby={`credentials-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

const ShopifyPriceSetterSubTab = () => {
  const [credentialsSubTab, setCredentialsSubTab] = useState(0);

  const handleCredentialsSubTabChange = (event, newValue) => {
    setCredentialsSubTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card>
        <CardContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={credentialsSubTab}
              onChange={handleCredentialsSubTabChange}
              aria-label="credentials tabs"
            >
              <Tab label="Margin Rules" />
            </Tabs>
          </Box>

          {/* Shopify Margin Rules Tab */}
          <TabPanel value={credentialsSubTab} index={0}>
            <ShopifyMarginRulesSubTab />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ShopifyPriceSetterSubTab;
